// extracted by mini-css-extract-plugin
module.exports = {"body":"styles__body___16az7","header-wrapper":"styles__header-wrapper___132Pl","loading":"styles__loading___240oK"};